import React from 'react';
import { Field, Pill, inputCls, slug } from './atoms';
import { US_STATES, CITIZENSHIP } from './constants';

const Step2Origin = ({ form, errors, upd, setField }) => (
  <div data-testid="step-2">
    <div className="mb-5">
      <h1 className="text-xl sm:text-2xl font-light" data-testid="step2-headline">
        Where are you moving from?
      </h1>
      <p className="text-sm mt-1 text-[#5A6B73]">A little context lets us tailor the visa + tax sections.</p>
    </div>

    <div className="space-y-4">
      <Field label="Current US state" error={errors.current_us_state} testId="field-us-state">
        <select value={form.current_us_state} onChange={upd('current_us_state')}
          className={inputCls(errors.current_us_state)} data-testid="onboarding-us-state">
          <option value="">Select a state…</option>
          {US_STATES.map((s) => <option key={s} value={s}>{s}</option>)}
        </select>
      </Field>

      <Field label="Current city" error={errors.current_city} testId="field-current-city">
        <input type="text" value={form.current_city} onChange={upd('current_city')}
          placeholder="e.g. San Diego" className={inputCls(errors.current_city)}
          data-testid="onboarding-current-city" />
      </Field>

      <Field label="US citizenship status" error={errors.us_citizenship_status} testId="field-citizenship">
        <div className="grid grid-cols-1 gap-2">
          {CITIZENSHIP.map((c) => (
            <Pill key={c} active={form.us_citizenship_status === c}
              onClick={() => setField('us_citizenship_status', c)}
              testId={`onboarding-citizenship-${slug(c)}`}>
              {c}
            </Pill>
          ))}
        </div>
      </Field>

      <Field label="Are you also a Mexican citizen?" error={errors.mexican_citizen} testId="field-mexican-citizen">
        <div className="grid grid-cols-2 gap-2">
          <Pill active={form.mexican_citizen === true}
            onClick={() => setField('mexican_citizen', true)}
            testId="onboarding-mxcitizen-yes">Yes</Pill>
          <Pill active={form.mexican_citizen === false}
            onClick={() => setField('mexican_citizen', false)}
            testId="onboarding-mxcitizen-no">No</Pill>
        </div>
      </Field>
    </div>
  </div>
);

export default Step2Origin;
